import Box from "@material-ui/core/Box";
import { Grid, Typography } from "@material-ui/core";
import React from "react";
import Match from "./Match";
import ScoreBoardContainer from "../../game-stats/containers/ScoreBoardContainer";
import { useMatchesContext } from "../../../state/matches/context";
import gameStatsContainerStyles from "../styles/GameStatsContainer.styles";

const GameStats = ({ print = false }) => {
	const classes = gameStatsContainerStyles();

	const { state } = useMatchesContext();

	const singles = state.singles();
	const doubles = state.doubles();

	const matchGridSizes = print ? { xs: 12 } : { xs: 12, md: 6 };

	return (
		<>
			<Box paddingX={4}>
				<ScoreBoardContainer />
			</Box>

			{!!singles.length && (
				<Box p={4}>
					<Typography variant="h4">Singles</Typography>
					<Grid className={classes.gridContainer} container>
						{singles.map((match) => (
							<Grid className={classes.gridItem} {...matchGridSizes} item>
								<Match match={match} disableActions />
							</Grid>
						))}
					</Grid>
				</Box>
			)}

			{!!doubles.length && (
				<Box p={4}>
					<Typography variant="h4">Doubles</Typography>
					<Grid className={classes.gridContainer} container>
						{doubles.map((match) => (
							<Grid className={classes.gridItem} {...matchGridSizes} item>
								<Match match={match} disableActions />
							</Grid>
						))}
					</Grid>
				</Box>
			)}
		</>
	);
};

export default GameStats;
